
















import Vue from 'vue';
import DocumentTypeConfiguration from '@/components/configuration/cabinet/DocumentTypeConfiguration.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { EditMode, CabinetConfigurationModel, DocumentTypeConfigurationModel, StoreConstants } from '@/types';
import { mapActions } from 'vuex';
import { CabinetConfigurationService } from '@/services/CabinetConfigurationService';
import { CabinetConfigurationHelper } from '@/mixins';
import { ObjectUtils } from '@/utils/objectUtils';

export default Vue.extend({
  mixins: [CabinetConfigurationHelper],
  data() {
    return {
      submitting: false,
      cabinetConfiguration: {} as CabinetConfigurationModel,
      documentTypeConfiguration: {} as DocumentTypeConfigurationModel,
      isLoading: true
    };
  },
  methods: {
    ...mapActions('configurationStore', ['getConfigurationTree']),
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage
    ]),
    async getCabinetConfigurationSettingsAsync(this: any) {
      await this.getCabinetConfigurationSettingsWithErrorPage();
    },
    async getCabinetConfigurationAsync(this: any) {
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.getCabinetConfigurationWithErrorPageAsync(
          this.$route.params.cabinetId
        );
        this.documentTypeConfiguration = this.cabinetConfiguration.documentTypes.find(
          (docType: DocumentTypeConfigurationModel) => docType.id === Number(this.$route.params.documentTypeId)
        );
      } catch (error) {
        this.$log(error);
      }
    },
    async onSubmitAsync(this: any, cabinetConfiguration: CabinetConfigurationModel) {
      this.submitting = true;
      try {
        this.cabinetConfiguration = await CabinetConfigurationService.updateDocumentTypeAsync(cabinetConfiguration);
        await this.getConfigurationTree();
        this.navigateToDocumentTypeDashboard(this.cabinetConfiguration.id, this.documentTypeConfiguration.id);
      } catch (error) {
        this.$log(error);
      } finally {
        this.submitting = false;
      }
    },
    onCancel(this: any) {
      this.navigateToDocumentTypeDashboard(this.cabinetConfiguration.id, this.documentTypeConfiguration.id);
    }
  },
  computed: {
    editMode(this: any) {
      return this.validLock ? EditMode.Edit : EditMode.View;
    },
    documentTypeConfigurationLoaded(this: any) {
      return !ObjectUtils.isNullOrEmpty(this.documentTypeConfiguration);
    }
  },
  components: {
    DocumentTypeConfiguration,
    LoadingSpinner
  },
  created(this: any) {
    this.EDIT_MODE = EditMode.Edit;
    // tslint:disable-next-line:max-line-length
    this.$route.meta.treePath = `/configuration/cabinet/${this.$route.params.cabinetId}/documenttype/${this.$route.params.documentTypeId}/dashboard`;
  },
  beforeDestroy(this: any) {
    this.$route.meta.treePath = null;
  },
  async mounted(this: any) {
    await this.getLock();
    await this.getCabinetConfigurationAsync();
    await this.getCabinetConfigurationSettingsAsync();
    this.isLoading = false;
  }
});
